// extracted by css-extract-rspack-plugin
export default {"timestamp":"ReviewTitle-module__timestamp__lJtUR"};